import { hsmBackendClient } from './client';
import { IControllerResponse } from './types';

export interface MetaPreview {
  websiteId: string;
  wabaId: string | null;
  fbPageAccessToken: string | null;
  externalId: string | null;
  /** `false` when Kori data is incomplete (e.g. externalId) → blocks the alta. */
  complete: boolean;
}

/**
 * Reads the Meta credentials/data of a channel from Kori, shown to the
 * executive before confirming a Meta line alta. Hits
 * `GET /website/{websiteId}/hsm/meta-preview`. When `complete` is `false`
 * (e.g. a missing externalId) the UI disables the "Confirmar alta" button.
 */
export async function getMetaPreview(websiteId: string): Promise<MetaPreview> {
  const response = await hsmBackendClient.get<IControllerResponse<MetaPreview>>(
    `/website/${encodeURIComponent(websiteId)}/hsm/meta-preview`
  );

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
